"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./AiCallAgentServicesCardSection.module.css";
import ServiceCard from "../../components/ServiceCard";
import aiCallAgentServicesData from "../../data/ai-call-agent";

export default function AiCallAgentServicesCardSection({ dynamicData }) {
  const { data: backendPageData } = useServiceData();

  // Requirement 4: dynamicData (from dispatcher) || backendPageData (global fetch) || static fallback
  const services = dynamicData || backendPageData?.services;
  const displayData = (services?.items && services.items.length > 0) ? services.items : aiCallAgentServicesData;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="text-center mb-4" data-reveal="slide-up">
          <div className={styles.eyebrow}>{services?.title || "AI Call Agent"}</div>
          <h2 className={styles.title}>{services?.subtitle || "Voice AI Services"}</h2>
        </div>

        <div className="row g-3 g-md-4" data-reveal="stagger-up">
          {displayData.map((card) => (
            <div className="col-12 col-md-6 col-lg-4" key={card.title}>
              <ServiceCard
                title={card.title}
                description={card.description}
                bullets={card.bullets} tags={card.tags}
                minHeight={card.minHeight ?? 420}
                accent={card.accent}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
